import * as React from 'react';
import {StyleSheet} from 'react-native';

export default () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={styles.icon}>
    <path
      d="M29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M22.707 15.7066C23.0977 15.316 23.0977 14.6816 22.707 14.2909L18.7068 10.2907C18.3162 9.90009 17.6818 9.90009 17.2911 10.2907C16.9005 10.6814 16.9005 11.3158 17.2911 11.7064L19.585 14.0003H13.0003C12.4471 14.0003 12.0002 14.4472 12.0002 15.0003C12.0002 15.5535 12.4471 16.0004 13.0003 16.0004H19.585L17.2911 18.2943C16.9005 18.6849 16.9005 19.3193 17.2911 19.7099C17.6818 20.1006 18.3162 20.1006 18.7068 19.7099L22.707 15.7098V15.7066ZM12.0002 10.0001C12.5534 10.0001 13.0003 9.5532 13.0003 9.00005C13.0003 8.4469 12.5534 8 12.0002 8H10.0001C8.34382 8 7 9.34382 7 11.0001V19.0005C7 20.6569 8.34382 22.0007 10.0001 22.0007H12.0002C12.5534 22.0007 13.0003 21.5538 13.0003 21.0006C13.0003 20.4475 12.5534 20.0006 12.0002 20.0006H10.0001C9.44699 20.0006 9.0001 19.5537 9.0001 19.0005V11.0001C9.0001 10.447 9.44699 10.0001 10.0001 10.0001H12.0002Z"
      fill="white"
    />
  </svg>
);

const styles = StyleSheet.create({
  icon: {marginLeft: 15},
});
